export const typography = {
  '10_500': {
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '-0.02em',
  },
  '11_400': {
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '-0.02em',
  },
  '12_400': {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '-0.02em',
  },
  '12_500': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '-0.02em',
  },
  '12_600': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '-0.02em',
  },
  '13_300': {
    fontSize: '13px',
    fontWeight: 300,
    lineHeight: '18px',
    letterSpacing: '-0.02em',
  },
  '13_400': {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '-0.02em',
  },
  '13_500': {
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18px',
    letterSpacing: '-0.02em',
  },
  '13_600': {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
    letterSpacing: '-0.02em',
  },
  '14_400': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '-0.02em',
  },
  '14_500': {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.02em',
  },
  '14_600': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '-0.02em',
  },
  '16_400': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '-0.02em',
  },
  '16_500': {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.02em',
  },
  '16_600': {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '-0.02em',
  },
  '18_400': {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '25px',
    letterSpacing: '-0.36px',
  },
  '18_500': {
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '25px',
    letterSpacing: '-0.36px',
  },
  '18_600': {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '25px',
    letterSpacing: '-0.36px',
  },
  '20_400': {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    letterSpacing: '-0.02em',
  },
  '20_600': {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px',
    letterSpacing: '-0.02em',
  },
  '24_600': {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: '-0.02em',
  },
  '32_600': {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '44px',
    letterSpacing: '-0.02em',
  },
  '32_800': {
    fontSize: '32px',
    fontWeight: 800,
    lineHeight: '44px',
    letterSpacing: '-0.02em',
  },
  '40_600': {
    fontSize: '40px',
    fontWeight: 600,
    lineHeight: '54px',
    letterSpacing: '-0.02em',
  },
  '40_800': {
    fontSize: '40px',
    fontWeight: 800,
    lineHeight: '54px',
    letterSpacing: '-0.02em',
  },
  '48_800': {
    fontSize: '48px',
    fontWeight: 800,
    lineHeight: '64px',
    letterSpacing: '-0.02em',
  },
  '56_800': {
    fontSize: '56px',
    fontWeight: 800,
    lineHeight: '72px',
    letterSpacing: '-0.02em',
  },
};

export const semanticTypography = {
  underline_12_400: {
    ...typography['12_400'],
    textDecoration: 'underline',
  },
  underline_13_400: {
    ...typography['13_400'],
    textDecoration: 'underline',
  },
  underline_14_400: {
    ...typography['14_400'],
    textDecoration: 'underline',
  },
  underline_16_400: {
    ...typography['16_400'],
    textDecoration: 'underline',
  },
  underline_20_400: {
    ...typography['20_400'],
    textDecoration: 'underline',
  },
  delete_12_400: {
    ...typography['12_400'],
    textDecoration: 'line-through',
  },
  delete_13_400: {
    ...typography['13_400'],
    textDecoration: 'line-through',
  },
  delete_14_400: {
    ...typography['14_400'],
    textDecoration: 'line-through',
  },
  delete_16_400: {
    ...typography['16_400'],
    textDecoration: 'line-through',
  },
  delete_20_400: {
    ...typography['20_400'],
    textDecoration: 'line-through',
  },
};

export const typographyStyle = {
  ...typography,
  ...semanticTypography,
};
